import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {RangeHeaderComponent} from "@irb-common/components/grid/renderers/range.header.component";
import {RangeCellComponent} from "@irb-common/components/grid/renderers/range.cell.component";
import {ComPrAllocationsComponent} from "@irb/irb-editors/editor-portfolio-result/com-pr-allocations/com-pr-allocations.component";
import {PrAllocationsService, PrApplicationService} from "@irb/irb-editors/editor-portfolio-result/services";
import {CallToActionCellComponent} from '@irb-common/components/grid/renderers/calltoaction.cell.component';
import {IPortfolioResultModelHistory} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {ComPrHeaderGroupComponent} from '@irb/irb-editors/editor-portfolio-result/com-pr-header-group/com-pr-header-group.component';

import {
    ColDef,
    ICellRendererParams,
    //ValueFormatterParams,
    ValueGetterParams,
    IAggFuncParams
} from 'ag-grid-community';


@Injectable({
    providedIn: "root"
})
export class ComPrAllocationsGridLayoutService implements GridLayoutService<ComPrAllocationsComponent> {

    constructor(private pralloc: PrAllocationsService, private pras: PrApplicationService) {
    }

    getFrameworkComponents() {
        return {
            "RangeCellComponent": RangeCellComponent,
            "CallToActionCellComponent": CallToActionCellComponent,
            "ComPrHeaderGroupComponent": ComPrHeaderGroupComponent
        };
    }

    getAggFuncs(parent: ComPrAllocationsComponent) {
        return {
            'secRelVariance': (params: IAggFuncParams): number => {
                if(params && params.values){
                const totalVariance = params.values.map((value: any) => value.secAbsVariance)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const totalTarget = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return totalVariance ? totalTarget ? (totalVariance * 100) / totalTarget : 100 : 0;
                }
            },
            'secRelVarianceAfterAdj': (params: IAggFuncParams): number => {
                if(params && params.values){
                const totaVariance = params.values.map((value: any) => value.secAbsVarianceAfterAdj)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const totalTarget = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return totaVariance ? totalTarget ? (totaVariance * 100) / totalTarget : 100 : 0;
                }
            },
            'secAbsVariance': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secCurPercntVal = params.values.map((value: any) => value.secCurPercntVal)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return secCurPercntVal - secModelTargetPercnt;
                }
            },
            'secAbsVarianceAfterAdj': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secPercntValAfterAdj = params.values.map((value: any) => value.secPercntValAfterAdj)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                return secPercntValAfterAdj - secModelTargetPercnt;
                }
            },
            'secDolrVariance': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secMktVal = params.values.map((value: any) => value.secMktVal)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const mktValAfterAdj = params.values.map((value: any) => value.mktValAfterAdj).shift();
                return secMktVal - ((secModelTargetPercnt / 100) * mktValAfterAdj);
                }
            },
            'secDolrVarianceAfterAdj': (params: IAggFuncParams): number => {
                if(params && params.values){
                const secMktValAfterAdj = params.values.map((value: any) => value.secMktValAfterAdj)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const secModelTargetPercnt = params.values.map((value: any) => value.secModelTargetPercnt)
                    .reduce((acc: number, val: number) => acc + val, 0);
                const mktValAfterAdj = params.values.map((value: any) => value.mktValAfterAdj).shift();
                return secMktValAfterAdj - ((secModelTargetPercnt / 100) * mktValAfterAdj);
                }
            },
            'rangeCellAggFunc': (params: IAggFuncParams) => {
                if(this.pralloc.group === 'ungroupedAllocLabel' && params.values.length > 0 && params.values[0]) {
                    const d: IPortfolioResultModelHistory = parent.data.modelHistoryList.find((x: IPortfolioResultModelHistory) => x.securitySymbol === params.values[0].parentSecSymb);
                    
                    if(d) {
                        const aggSecCurPercntVal = params.values.reduce((acc: number, val: any) => acc + val.secCurPercntVal, 0);
                        
                        return {
                            inRange: (aggSecCurPercntVal <= d.maximumPercentage && aggSecCurPercntVal >= d.minimumPercentage),
                            aboveRange: aggSecCurPercntVal > d.maximumPercentage
                        };
                    }
                } else if(params.values.length > 0 && params.values[0]) {
                    const totalCount = params.values.length;
                    const inRangeCountBefore = params.values.map((value: any) => value.isWithinRangeBefore ? 1 : 0)
                    .reduce((acc: number, val: number) => acc + val, 0);
                    return inRangeCountBefore < totalCount ? 0 - totalCount + inRangeCountBefore : totalCount;
                }
            },
            'rangeCellAggFuncAfterAdj': (params: IAggFuncParams) => {
                if(this.pralloc.group === 'ungroupedAllocLabel' && params.values.length > 0 && params.values[0]) {
                    const d: IPortfolioResultModelHistory = parent.data.modelHistoryList.find((x: IPortfolioResultModelHistory) => x.securitySymbol === params.values[0].parentSecSymb);
                    
                    if(d) {
                        const aggSecPercntValAfterAdj = params.values.reduce((acc: number, val: any) => acc + val.secPercntValAfterAdj, 0);
                        
                        return {
                            inRange: (aggSecPercntValAfterAdj <= d.maximumPercentage && aggSecPercntValAfterAdj >= d.minimumPercentage),
                            aboveRange: aggSecPercntValAfterAdj > d.maximumPercentage
                        };
                    }
                } else if(params.values.length > 0 && params.values[0]) {
                    const totalCount = params.values.length;
                    const inRangeCountAfter = params.values.map((value: any) => value.isWithinRangeAfter ? 1 : 0)
                    .reduce((acc: number, val: number) => acc + val, 0);
                    return inRangeCountAfter < totalCount ? 0 - totalCount + inRangeCountAfter : totalCount;
                }
            }
        };
    }

    getAutoGroupColumnDef(parent: ComPrAllocationsComponent): ColDef {
        const b: any = {
            headerName: 'Name',
            field: "secSymb",
            flex: 1,
            suppressMovable: true,
            cellRendererParams: {
                getTemplate: (params: any) => parent.getAllocationDescription(params),
                suppressCount: true,
                calltoactionUsesHover: true,
                calltoactionMaxWidth: 'none',
                calltoactionHorizontalOffset: 20,
                valueFormatter: (params: any) => {
                    if (params.data) {
                        if (params.data.secExclusionType) {
                            return "* " + params.value;
                        } else if (params.data.isEquivalentChild && params.data.countParent > 1) {
                            return params.value + " (Split)";
                        } else if (typeof params.data.groupSize !== "undefined") {
                            return params.value + " (" + params.data.groupSize + ")";
                        }
                    }
                    return params.value;
                },
                calltoactionclass: (params: any) => {
                    if (params.data && params.data.secType === 'GROUP' && params.data.rebalCompSecurityDTOList) {
                        return 'link-to-click';
                    }
                    return 'no-link-class'
                },
                calltoactionClick: (params: any) => {
                    parent.showGroupComponents(params);
                },
                showWarnIcon: (_params: any) => this.pralloc.group === 'ungroupedAllocLabel' && _params.data?.secType != 'UI_GROUP' && this.pras.getSecurityTradeActionNote(parent.data, _params.data?.secSymb).length > 0,
                getWarnIconTemplate: (_params: any) => parent.getSecurityTradeActionNoteTemplate(this.pras.getSecurityTradeActionNote(parent.data, _params.data?.secSymb))     
            }
        };

        if(this.pralloc.group === 'ungroupedAllocLabel') {
            b.headerComponentParams = {
                irbColInfo: `A warning icon in this column means that allocation has information to review. Select the View Explanations button for more.`
            };
        }

        if(this.pralloc.group === 'ungroupedAllocLabel' && !this.pralloc.showEquivalents) {
            b.cellRenderer = 'CallToActionCellComponent';
            b.cellRendererParams.calltoactionHorizontalOffset = -20;            
        } else {
            b.showRowGroup = true;
            b.cellRenderer = 'agGroupCellRenderer';
            b.cellRendererParams.calltoactionHorizontalOffset =20;
            b.cellRendererParams.innerRenderer = 'CallToActionCellComponent';
            b.cellRendererParams.innerRendererParams = {
                calltoactionUsesHover: true,
                calltoactionMaxWidth: 'none',
                calltoactionHorizontalOffset: 20,
                calltoactionUseTruncationParent: false
            };
            b.cellRendererParams.suppressDoubleClickExpand = true;
            b.cellRendererParams.suppressEnterExpand = true;
        }        

        return b;
    }

    getColumnDefs(parent: ComPrAllocationsComponent) {
        return [
            {
                headerName: "Allocations",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        ...this.getAutoGroupColumnDef(parent),
                        colId: 'ALLOCATION',
                        flex: 3,
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "multi": (params: any) => { return params.data?.isACLevelMulti },
                            "bold": (params: any) => { return params.data?.secType == 'UI_GROUP' },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                    },
                    {
                        headerName: "Target $",
                        suppressMovable: true,
                        field: "secModelTargetDollar",
                        aggFunc: 'sum',
                        flex: 2,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '$',
                            decimalPosition: '2',
                            isDoubleDash: this.isValueDisplaySuppressed('secModelTargetDollar', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        }
                    },
                    {
                        headerName: "Target %",
                        suppressMovable: true,
                        field: "secModelTargetPercnt",
                        aggFunc: 'sum',
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secModelTargetPercnt', params.data),
                            isBlank: params.node.rowPinned && params.value === undefined
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        }
                    }
                ]
            },
            {
                headerName: "Current Holdings",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        headerName: "Value $",
                        suppressMovable: true,
                        field: "secMktVal",
                        flex: 2,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            type: 'currency',
                            decimalPosition: '2'
                        },
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Value %",
                        suppressMovable: true,
                        field: "secCurPercntVal",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secCurPercntVal', params.data),
                            isBlank: params.node.rowPinned && params.value === undefined
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Variance $",
                        suppressMovable: true,
                        field: "secDolrVariance",
                        flex: 2,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secMktVal: params.data.secMktVal,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    mktValAfterAdj: params.data.portfolioMktValueAfterAdj,
                                    fieldValue: params.data.secDolrVariance,
                                    toString: () => params.data.secDolrVariance
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '$',
                            decimalPosition: '2',
                            isDoubleDash: this.isValueDisplaySuppressed('secDolrVariance', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                        aggFunc: 'secDolrVariance'
                    },
                    {
                        headerName: "Abs %",
                        headerTooltip: "Absolute %",
                        suppressMovable: true,
                        field: "secAbsVariance",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secCurPercntVal: params.data.secCurPercntVal,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secAbsVariance,
                                    toString: () => params.data.secAbsVariance
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secAbsVariance', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                        aggFunc: 'secAbsVariance'
                    },
                    {
                        headerName: "Rel %",
                        headerTooltip: "Relative %",
                        suppressMovable: true,
                        field: "secRelVariance",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secAbsVariance: params.data.secAbsVariance,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secRelVariance,
                                    toString: () => params.data.secRelVariance
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secRelVariance', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                        aggFunc: 'secRelVariance'
                    }
                ]
            },
            {
                headerName: parent.getInRangeCount("isWithinRangeBefore"),
                marryChildren:true,
                suppressMovable: true,
                headerGroupComponent: "ComPrHeaderGroupComponent",
                children: [
                    {
                        headerName: "Target Range",
                        sortable: false,
                        suppressMovable: true,
                        valueGetter: (params: ValueGetterParams): any => {
                            if (!params.node.group && !params.node.rowPinned) {
                                return {
                                    isWithinRangeBefore: params.data.isWithinRangeBefore,
                                    secCurPercntVal: params.data.secCurPercntVal,
                                    parentSecSymb: params.data.parentSecSymb
                                }
                            } else {
                                return "";
                            }
                        },
                        cellClass: ["bold"],
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeBefore }
                        },
                        cellRenderer: 'RangeCellComponent',
                        cellRendererParams: (params: ICellRendererParams) => {
                            if(params.data && params.data.secType != "UI_GROUP") {
                                return {
                                    inRange: params.data.isWithinRangeBefore,
                                    aboveRange: params.data.isAboveRangeBefore,
                                    excluded: !!(params.data.secExclusionType || (this.showEquivalents()
                                        && (params.data.isEquivalentChild || params.data.isEquivalentParent))),
                                    showIconWithLabel: true
                                }
                            } else if(this.pralloc.group === 'ungroupedAllocLabel' && typeof params.value === "object") {
                                return {
                                    inRange: params.value.inRange,
                                    aboveRange: params.value.aboveRange,
                                    showIconWithLabel: true
                                }
                            } else {
                                return {
                                    absoluteValue: true,
                                    inRange: params.value >= 0,
                                    showIconWithLabel: params.value >= 0
                                }
                            }
                        },
                        flex: 2,
                        minWidth: 90,
                        aggFunc: 'rangeCellAggFunc'
                    }
                ]
            },
            {
                headerName: "",
                headerClass: "adjustment grey",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        headerName: "Adjustments",
                        suppressMovable: true,
                        field: "secAdjAmt",
                        flex: 2,
                        headerClass: "adjustment grey",
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            decimalPosition: '2',
                            isBlank: params.node.rowPinned
                        }),
                        cellClass: (params: ICellRendererParams) => params.node.rowPinned ? ['adjustment grey irb-green', 'footer'] : 'adjustment grey irb-green',
                        aggFunc: 'sum'
                    }
                ]
            },
            {
                headerName: "After Adjustments",
                marryChildren:true,
                suppressMovable: true,
                children: [
                    {
                        headerName: "Value $",
                        suppressMovable: true,
                        field: "secMktValAfterAdj",
                        flex: 2,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: {
                            type: 'currency',
                            decimalPosition: '2'
                        },
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeAfter }
                        },
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Value %",
                        suppressMovable: true,
                        field: "secPercntValAfterAdj",
                        flex: 1,
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secPercntValAfterAdj', params.data),
                            isBlank: params.node.rowPinned && params.value === undefined
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeAfter }
                        },
                        aggFunc: 'sum'
                    },
                    {
                        headerName: "Variance $",
                        suppressMovable: true,
                        field: "secDolrVarianceAfterAdj",
                        flex: 2,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secMktValAfterAdj: params.data.secMktValAfterAdj,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    mktValAfterAdj: params.data.portfolioMktValueAfterAdj,
                                    fieldValue: params.data.secDolrVarianceAfterAdj,
                                    toString: () => params.data.secDolrVarianceAfterAdj
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '$',
                            decimalPosition: '2',
                            isDoubleDash: this.isValueDisplaySuppressed('secDolrVarianceAfterAdj', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeAfter }
                        },
                        aggFunc: 'secDolrVarianceAfterAdj'
                    },
                    {
                        headerName: "Abs %",
                        headerTooltip: "Absolute %",
                        suppressMovable: true,
                        field: "secAbsVarianceAfterAdj",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secPercntValAfterAdj: params.data.secPercntValAfterAdj,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secAbsVarianceAfterAdj,
                                    toString: () => params.data.secAbsVarianceAfterAdj
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secAbsVarianceAfterAdj', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeAfter }
                        },
                        aggFunc: 'secAbsVarianceAfterAdj'
                    },
                    {
                        headerName: "Rel %",
                        headerTooltip: "Relative %",
                        suppressMovable: true,
                        field: "secRelVarianceAfterAdj",
                        flex: 1,
                        valueGetter: (params: ValueGetterParams) => {
                            if (!params.node.group) {
                                return {
                                    secAbsVarianceAfterAdj: params.data.secAbsVarianceAfterAdj,
                                    secModelTargetPercnt: params.data.secModelTargetPercnt,
                                    fieldValue: params.data.secRelVarianceAfterAdj,
                                    toString: () => params.data.secRelVarianceAfterAdj
                                }
                            }
                        },
                        cellRenderer: 'cellRendererFormatter',
                        cellRendererParams: (params: ICellRendererParams) => ({
                            value: this.pralloc.group === 'ungroupedAllocLabel'?parseFloat(params.value):(params.data && params.value && params.value.fieldValue ? params.value.fieldValue : parseFloat(params.value)),
                            type: 'currency',
                            displaySymbol: '%',
                            decimalPosition: '1',
                            isDoubleDash: this.isValueDisplaySuppressed('secRelVarianceAfterAdj', params.data),
                            isBlank: params.node.rowPinned
                        }),
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeAfter }
                        },
                        aggFunc: 'secRelVarianceAfterAdj'
                    }
                 ]
                },
                {
                    headerName: parent.getInRangeCount("isWithinRangeAfter"),
                    marryChildren:true,
                    suppressMovable: true,
                    headerGroupComponent: "ComPrHeaderGroupComponent",
                    children: [
                    {
                        headerName: "Target Range",
                        sortable: false,
                        suppressMovable: true,
                        valueGetter: (params: ValueGetterParams): any => {
                            if (!params.node.group && !params.node.rowPinned) {
                                return {
                                    isWithinRangeAfter: params.data.isWithinRangeAfter,
                                    secPercntValAfterAdj: params.data.secPercntValAfterAdj,
                                    parentSecSymb: params.data.parentSecSymb
                                }
                                } else {
                                    return "";
                            }
                        },
                        cellClass: ["bold"],
                        cellClassRules: {
                            "footer": (params: any) => { return params.node.rowPinned },
                            "out-of-range-cell": (params: any) => { return params.data?.secType != "UI_GROUP" && !params.node.rowPinned && !params.data?.isWithinRangeAfter }
                        },
                        cellRenderer: 'RangeCellComponent',
                        cellRendererParams: (params: ICellRendererParams) => {
                                if(params.data && params.data.secType != "UI_GROUP") {
                                return {
                                    inRange: params.data.isWithinRangeAfter,
                                    aboveRange: params.data.isAboveRangeAfter,
                                    excluded: !!(params.data.secExclusionType || (this.showEquivalents()
                                            && (params.data.isEquivalentChild || params.data.isEquivalentParent))),
                                        showIconWithLabel: true
                                }
                            } else if(this.pralloc.group === 'ungroupedAllocLabel' && params.value) {   
                                return {
                                    inRange: params.value.inRange,
                                    aboveRange: params.value.aboveRange,
                                        showIconWithLabel: true
                                }
                            } else {
                                return {
                                    absoluteValue: true,
                                    inRange: params.value >= 0,
                                        showIconWithLabel: params.value >= 0
                                }
                            }
                        },
                        flex: 2,
                        minWidth: 90,
                        aggFunc: 'rangeCellAggFuncAfterAdj'
                    }
                ]
            }
        ];
    }

    isValueDisplaySuppressed(field: string, data: any): boolean {
        
        switch (field) {
            case 'secDolrVariance':
            case 'secDolrVarianceAfterAdj':
                return (data && (data.isEquivalentChild || data.isEquivalentParent)) && this.showEquivalents();
            case 'secCurPercntVal':
            case 'secPercntValAfterAdj':
                return !!(data && data.secExclusionType);
            case 'secRelVariance':
            case 'secAbsVariance':
            case 'secRelVarianceAfterAdj':
            case 'secAbsVarianceAfterAdj':
                return !!(data && (data.secExclusionType || ((data.isEquivalentChild || data.isEquivalentParent)
                    && this.showEquivalents())));
            default:
                return false;
        }
    }

    private showEquivalents(): boolean {
        return this.pralloc.showEquivalents && this.pralloc.group === 'ungroupedAllocLabel';
    }

    getDefaultHiddenState(parent: ComPrAllocationsComponent, fieldName: string, defaultState: boolean) {
        let s: any = JSON.parse(window.localStorage.getItem(parent.componentName) || "{}");

        if(s.COL_STATE) {
            let c: any  = JSON.parse(s.COL_STATE);

            if(c) {
                let d = c.find((x: any) => x.colId == fieldName);
                return d?.hide;
            }
        }

        return defaultState;
    }
}
